import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import { Input } from '@/shared/components/ui/input'
import { Modal, ModalFooter } from '@/shared/components/ui/modal'

interface ConfirmDialogProps {
  open: boolean
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  confirmText?: string
  tone?: 'primary' | 'danger'
  loading?: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  confirmText,
  tone = 'primary',
  loading,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const [typed, setTyped] = useState('')

  const handleClose = () => {
    setTyped('')
    onClose()
  }

  const canConfirm = confirmText === undefined || typed === confirmText

  return (
    <Modal description={description} onClose={handleClose} open={open} size="sm" title={title}>
      {confirmText !== undefined && (
        <div className="mb-4 space-y-1.5">
          <p className="text-sm text-[var(--color-text-soft)]">
            Введите <span className="font-semibold text-[var(--color-text)]">{confirmText}</span>{' '}
            для подтверждения
          </p>
          <Input
            autoFocus
            onChange={(e) => setTyped(e.target.value)}
            placeholder={confirmText}
            value={typed}
          />
        </div>
      )}
      <ModalFooter>
        <Button onClick={handleClose} type="button" variant="ghost">
          {cancelLabel}
        </Button>
        <Button
          disabled={!canConfirm}
          loading={loading}
          onClick={() => {
            if (canConfirm) {
              setTyped('')
              onConfirm()
            }
          }}
          type="button"
          variant={tone === 'danger' ? 'danger' : 'primary'}
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
